const SectionMessage = ({
  message,
  className,
  style,
}: {
  message: any;
  className?: string;
  style?: any;
}) => {
  return (
    <span className={`subtitle ${className}`} style={style}>
      {message}
    </span>
  );
};

export default SectionMessage;
